export default "__VITE_ASSET__G$R0v68w__"